import { GridContainer } from 'libs/ui';
import { Collection } from 'grids/collection/collection';

export const CollectionWrapper = (props) => {
  return (
    <GridContainer>
      <Collection {...props} />
    </GridContainer>
  );
};
